import styled from 'styled-components';

export const StyledUl = styled.ul`
    list-style-type: none;
`;
